<ng-container [ngSwitch]="mode">
  <div class="view-toolbar" [@inOutAnimation] *ngSwitchDefault>
    <div class="view-toolbar-inner">
      <app-pillbox>
        <app-view-tools [mode]="viewToolsMode.Main" (modeChange)="handleModeChange($event)"></app-view-tools>
      </app-pillbox>
    </div>
  </div>

  <div class="view-toolbar" [@inOutAnimation] *ngSwitchCase="viewToolsMode.Media">
    <div class="view-toolbar-inner">
      <app-pillbox [canExit]="canExit" (exit)="handleExitClick()">
        <app-view-media-bar></app-view-media-bar>
      </app-pillbox>
    </div>
  </div>

  <div class="view-toolbar" [@inOutAnimation] *ngSwitchCase="viewToolsMode.Tools">
    <div class="view-toolbar-inner">
      <app-pillbox [canExit]="canExit" (exit)="handleExitClick()">
        <app-view-tools [mode]="viewToolsMode.Tools"></app-view-tools>
      </app-pillbox>
    </div>
  </div>
</ng-container>